import { createReducer, on } from '@ngrx/store';

import { cashSettlementAction } from './cash-settlement.actions';

export const cashSettlementKey = 'cashSettlement';

export interface CashSettlementState {
  cashSettlementList: any;
  cashSettlementDetail: any;
  cashSettlementDraft: any;
  cashSettlementSubmit: any;
  cashSettlementSubmitTransferEvidence: any;
}

export const initialState: CashSettlementState = {
  cashSettlementList: null,
  cashSettlementDetail: null,
  cashSettlementDraft: null,
  cashSettlementSubmit: null,
  cashSettlementSubmitTransferEvidence: null
};

export const cashSettlementReducer = createReducer<CashSettlementState>(
  initialState,
  on(cashSettlementAction.cashSettlementListResponse, (state, response) => {
    return { ...state, cashSettlementList: response.response };
  }),
  on(cashSettlementAction.viewCashSettlementResponse, (state, response) => {
    return { ...state, cashSettlementDetail: response.response };
  }),
  on(cashSettlementAction.cashSettlementCreateDraftResponse, (state, response) => {
    return { ...state, cashSettlementDraft: response.response };
  }),
  on(cashSettlementAction.cashSettlementCreateDraftClear, (state) => {
    return { ...state, cashSettlementDraft: null };
  }),
  on(cashSettlementAction.cashSettlementSubmitDraftResponse, (state, response) => {
    return { ...state, cashSettlementSubmit: response.response };
  }),
  on(cashSettlementAction.cashSettlementSubmitDraftClear, (state) => {
    return { ...state, cashSettlementSubmit: null };
  }),
  on(cashSettlementAction.resetViewCashSettlementResponse, (state) => {
    return { ...state, cashSettlementDetail: null };
  }),
  on(cashSettlementAction.cashSettlementSubmitTransferEvidenceResponse, (state, response) => {
    return { ...state, cashSettlementSubmitTransferEvidence: response.response };
  }),
  on(cashSettlementAction.cashSettlementSubmitTransferEvidenceClear, (state) => {
    return { ...state, cashSettlementSubmitTransferEvidence: null };
  })
);
